import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WebCompProfileComponent } from './web-comp-profile.component';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from 'app/auth/auth.guard';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatDialogModule  } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatStepperModule } from '@angular/material/stepper';
import {MatDividerModule} from '@angular/material/divider';

import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
// TRANSLATE
import { TranslateModule } from '@ngx-translate/core';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import { ModalCompProfileComponent } from './modal-comp-profile/modal-comp-profile.component';
import {MatTooltipModule} from '@angular/material/tooltip';
const rutas: Routes = [
    // trust index
    {
        path     : 'web/company_profile',
        component: WebCompProfileComponent,
        canActivate: [AuthGuard]
    },
];
@NgModule({
  declarations: [WebCompProfileComponent, ModalCompProfileComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(rutas),
    TranslateModule,
    MatButtonModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDialogModule ,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatStepperModule,
    FlexLayoutModule,
    MatSlideToggleModule,
    FormsModule,
    ReactiveFormsModule,
    MatTooltipModule,
    MatDividerModule
  ],
  entryComponents: [WebCompProfileComponent]
})
export class WebCompProfileModule { }
